import { render } from "./AddOrEditPromotion.html?vue&type=template&id=e3253ab6&scoped=true"
import script from "./AddOrEditPromotion.js?vue&type=script&lang=js"
export * from "./AddOrEditPromotion.js?vue&type=script&lang=js"

import "./AddOrEditPromotion.css?vue&type=style&index=0&id=e3253ab6&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/Shiptech MyPlusRewards/mpr-web-admin-portal/src/MPR.MyPlusRewardsAdminPortal.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3253ab6"]])

export default __exports__